import { render } from "./LightingDemo.vue?vue&type=template&id=c48bd4d6&scoped=true&ts=true"
import script from "./LightingDemo.vue?vue&type=script&lang=ts"
export * from "./LightingDemo.vue?vue&type=script&lang=ts"

import "./LightingDemo.vue?vue&type=style&index=0&id=c48bd4d6&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48bd4d6"]])

export default __exports__